import React, { useState } from 'react';
import PropTypes from 'prop-types';

const EventSearchResult = (props) => {
  let sustainabilityBadge = '';

  const [showSecondaryContent, setShowSecondaryContent] = useState(false);

  if (
    props.tags &&
    drupalSettings.sustainability_tag &&
    props.tags.includes(drupalSettings.sustainability_tag)
  ) {
    sustainabilityBadge = 'content-liftup-sustainability_badge';
  }

  // The 'Z' is added, so that the timezone is interpreted correctly.
  const formattedStartDate =
    props.startDate &&
    new Date(props.startDate + 'Z').toLocaleDateString('fi-FI', {
      timeZone: 'Europe/Helsinki',
    });
  const formattedEndDate =
    props.endDate &&
    new Date(props.endDate + 'Z').toLocaleDateString('fi-FI', {
      timeZone: 'Europe/Helsinki',
    });

  const startTime =
    props.startDate &&
    new Date(props.startDate + 'Z').toLocaleTimeString('fi-FI', {
      timeZone: 'Europe/Helsinki',
      hour: '2-digit',
      minute: '2-digit',
      hour24: true,
    });

  const endTime =
    props.endDate &&
    new Date(props.endDate + 'Z').toLocaleTimeString('fi-FI', {
      timeZone: 'Europe/Helsinki',
      hour: '2-digit',
      minute: '2-digit',
      hour24: true,
    });

  return (
    <div
      className={`content-liftup ${showSecondaryContent ? 'show-secondary' : ''} ${sustainabilityBadge}`}
    >
      <div
        className={`content-liftup__image content-liftup__image--main ${!showSecondaryContent ? 'is-visible' : ''}`}
      >
        {props.images[0] && (
          <img
            src={props.images[0]}
            alt={Drupal.t('Event image')}
            loading="lazy"
          />
        )}
      </div>
      <div
        className={`content-liftup__image content-liftup__image--secondary ${showSecondaryContent ? 'is-visible' : ''}`}
      >
        {props.images[1] && (
          <img src={props.images[1]} alt={Drupal.t('Event image')} />
        )}
      </div>

      <div
        className={`content-liftup__primary_section ${!showSecondaryContent ? 'is-visible' : ''}`}
      >
        <div className="content-liftup__primary_section--title">
          <h3>
            <a href={props.url}>{props.title}</a>
          </h3>
        </div>
        <div className="content-liftup__primary_section--content">
          <div className="content-liftup-dates">
            <svg className="icon">
              <use href="/themes/custom/ski_valley/dist/icons.svg#event-calendar"></use>
            </svg>
            <span>
              {formattedStartDate}
              {formattedEndDate && ' - ' + formattedEndDate}
            </span>
          </div>

          {startTime !== '00.00' && endTime !== '23.59' && (
            <div className="content-liftup-times">
              <svg className="icon">
                <use href="/themes/custom/ski_valley/dist/icons.svg#clock"></use>
              </svg>
              <span>
                {startTime} - {endTime}
              </span>
            </div>
          )}

          {props.price && (
            <div className="field-price">
              <svg className="icon">
                <use href="/themes/custom/ski_valley/dist/icons.svg#euro"></use>
              </svg>
              <span>
                {Drupal.t('Starting from')} {props.price} €
              </span>
            </div>
          )}
        </div>
      </div>

      <div
        className={`content-liftup__secondary_section ${showSecondaryContent ? 'is-visible' : ''}`}
      >
        <div className="content-liftup__secondary_content content-liftup__secondary_content--">
          <div className="field-description field--type-string-long field--view-mode-teaser">
            {props.description}
          </div>
        </div>
      </div>

      <div className="content-liftup__bottom_section content-liftup__bottom_section--">
        <a href={props.url} className="button vertical-liftup__cta__button">
          {Drupal.t('Read more')}
        </a>

        {props.description && (
          <a
            className="content-liftup__view-change content-liftup__view-change--"
            tabIndex="0"
            onClick={() => setShowSecondaryContent(!showSecondaryContent)}
          >
            <span className="secondary-toggle-text">
              {Drupal.t('Quick view')}
            </span>
            <span className="main-toggle-text">{Drupal.t('Back')}</span>
          </a>
        )}
      </div>
    </div>
  );
};

EventSearchResult.propTypes = {
  title: PropTypes.array,
  description: PropTypes.string,
  url: PropTypes.array,
  images: PropTypes.array,
  startDate: PropTypes.array,
  endDate: PropTypes.array,
  category: PropTypes.array,
  tags: PropTypes.array,
  price: PropTypes.number,
};

export default EventSearchResult;
